import React from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import TabNavigation from 'src/components/sticky-tab-nav';

import { MAX_RESULTS } from '../../constants';

import { TabAnchor } from './types';

type Props = {
  brandsCount: number;
  categoriesCount: number;
  productsCount: number;
};

export const SearchResultsNavigation = (props: Props) => {
  const { market, t } = useAppContext();

  const { brandsCount, categoriesCount, productsCount } = props;

  const formattedProductsCount =
    (productsCount || 0) >= MAX_RESULTS
      ? `${MAX_RESULTS.toLocaleString(market.localeStandard)}+`
      : (productsCount || 0).toLocaleString(market.localeStandard);
  const defaultActiveTab =
    categoriesCount > 0 ? TabAnchor.CATEGORIES : TabAnchor.PRODUCTS;

  return (
    <TabNavigation
      defaultActiveTabId={defaultActiveTab}
      tabs={[
        ...(categoriesCount
          ? [
              {
                id: TabAnchor.CATEGORIES,
                title: `${t(
                  'search',
                  'categories.title'
                )} (${categoriesCount.toLocaleString(market.localeStandard)})`,
              },
            ]
          : []),
        ...(productsCount
          ? [
              {
                id: TabAnchor.PRODUCTS,
                title: `${t(
                  'search',
                  'products.title'
                )} (${formattedProductsCount})`,
              },
            ]
          : []),
        ...(brandsCount
          ? [
              {
                id: TabAnchor.BRANDS,
                title: `${t(
                  'search',
                  'brands.title'
                )} (${brandsCount.toLocaleString(market.localeStandard)})`,
              },
            ]
          : []),
      ]}
    />
  );
};
